import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";

@Component({
  selector: "app-whatsapp",
  templateUrl: "./whatsapp.component.html",
  styleUrls: ["./whatsapp.component.scss"]
})
export class WhatsappComponent implements OnInit {
  public itemForm: FormGroup;
  public valid = false;

  constructor(
    public ref: MatDialogRef<WhatsappComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.buildItemForm();
  }

  public cpfcnpjmask = function(rawValue) {
    const numbers = rawValue.match(/\d/g);
    let numberLength = 0;
    if (numbers) {
      numberLength = numbers.join("").length;
    }
    if (numberLength <= 11) {
      return [
        /[0-9]/,
        /[0-9]/,
        " ",
        "(",
        /[0-9]/,
        /[0-9]/,
        ")",
        " ",
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        "-",
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/
      ];
    } else {
      return [
        /[0-9]/,
        /[0-9]/,
        " ",
        "(",
        /[0-9]/,
        /[0-9]/,
        ")",
        " ",
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        "-",
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/
      ];
    }
  };

  buildItemForm() {
    this.itemForm = this.fb.group({
      whatsapp: ["", Validators.required]
    });
  }

  submit() {
    //this.ref.close(this.itemForm.value);
  }

  catchEntry(_value: string) {
    const entry =
      _value !== null ? _value.toString().replace(/[^\d]+/g, "").length : 0;
    const input =
      _value !== null ? _value.toString().replace(/[^\d]+/g, "") : "";
    this.itemForm.value.whatsapp = input;

    if (entry !== null && entry > 11) {
      this.valid = true;
    } else {
      this.valid = false;
    }
  }
}
